import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { get as _get, isUndefined as _isUndefined } from 'lodash-es';
import { Observable, of as observableOf, of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { HttpOptions } from 'src/app/interfaces/httpOptions';
import { RequestParam } from 'src/app/interfaces/requestParam';
import { ServerResponse } from 'src/app/interfaces/serverResponse';
import { API_ERRORS } from 'src/app/static/api.constant';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = ''; // Set your base URL here if needed
  }

  get(requestParam: RequestParam): Observable<ServerResponse> {
    const httpOptions: HttpOptions = {
      headers: requestParam.headers || this.getHeader(),
      params: requestParam.params,
    };

    return this.http.get<ServerResponse>(requestParam.url, httpOptions).pipe(
      mergeMap((data: ServerResponse) => {
        if (_isUndefined(data)) {
          return throwError(
            () => new Error(_get(data, 'params.errMsg') || 'Unknown error')
          );
        }
        return observableOf(data);
      })
    );
  }

  post(requestParam: RequestParam): Observable<ServerResponse> {
    const httpOptions: HttpOptions = {
      headers: requestParam.headers
        ? this.getHeader(requestParam.headers)
        : this.getHeader(),
      params: requestParam.params,
    };
    return this.http
      .post<ServerResponse>(requestParam.url, requestParam.data, httpOptions)
      .pipe(
        mergeMap((data: ServerResponse) => {
          if (_isUndefined(data)) {
            return throwError(
              () => new Error(_get(data, 'params.errMsg') || 'Unknown error')
            );
          }
          return observableOf(data);
        })
      );
  }

  patch(requestParam: RequestParam): Observable<ServerResponse> {
    const httpOptions: HttpOptions = {
      headers: requestParam.headers ? requestParam.headers : this.getHeader(),
      params: requestParam.params,
    };
    return this.http
      .patch<ServerResponse>(requestParam.url, requestParam.data, httpOptions)
      .pipe(
        mergeMap((data: ServerResponse) => {
          if (_isUndefined(data)) {
            return throwError(
              () => new Error(_get(data, 'params.errMsg') || 'Unknown error')
            );
          }
          return observableOf(data);
        })
      );
  }

  put(requestParam: RequestParam): Observable<ServerResponse> {
    const httpOptions: HttpOptions = {
      headers: requestParam.headers ? requestParam.headers : this.getHeader(),
      params: requestParam.params,
    };
    return this.http
      .put<ServerResponse>(requestParam.url, requestParam.data, httpOptions)
      .pipe(
        mergeMap((data: ServerResponse) => {
          if (_isUndefined(data)) {
            return throwError(
              () => new Error(_get(data, 'params.errMsg') || 'Unknown error')
            );
          }
          return observableOf(data);
        }),
        catchError((err) => {
          console.log('post service error');
          return of(err);
        })
      );
  }

  downloadFile(requestParam: RequestParam): Observable<HttpResponse<Blob>> {
    const httpOptions = {
      headers: requestParam.headers || new HttpHeaders(),
      params: requestParam.params || new HttpParams(),
      responseType: 'blob' as 'blob',
      observe: 'response' as const,
    };

    return this.http.post(requestParam.url, requestParam.data, httpOptions);
  }

  private getHeader(headers?: HttpOptions['headers']): HttpOptions['headers'] {
    const default_headers: Record<string, string> = {
      Accept: 'application/json',
    };
    if (headers) {
      return new HttpHeaders({ ...default_headers, ...headers });
    } else {
      return new HttpHeaders(default_headers);
    }
  }

  // ... existing code ...

  getError(response: any) {
    try {
      const errors = response?.error?.errors;
      if (errors) {
        const errorObj =
          Array.isArray(errors) && !!errors.length
            ? errors[0]
            : API_ERRORS.defaultError;
        return errorObj;
      }
      return API_ERRORS.defaultError;
    } catch (e) {
      console.log(e);
      return null;
    }
  }
}
